<template>
  <div class="gmf-comment-form-text-length gmf-text-small" :class="{'gmf-error': exceedsMaxLength}">{{ textLength }} / {{ maxChars }}</div>
</template>

<style>
.gmf-comment-form-text-length {
  float: right;
  margin-top: var(--gmf-p-2);
}
.gmf-comment-form-text-length.gmf-error {
  color: var(--gmf-col-error);
}
</style>

<script>
export default {
  props: [ 'text', 'maxChars' ],
  computed: {
    textLength () {
      return this.text.length;
    },
    exceedsMaxLength () {
      return this.textLength > this.maxChars;
    },
  },
};
</script>
